import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import '@aws-amplify/ui-react/styles.css';
import './index.css';
import Header from './components/Header';
import Footer from './components/Footer';
import { ToastContainer } from 'react-toastify';
import { Button } from 'semantic-ui-react';
import { Auth } from 'aws-amplify';
import Player from './routes/Player';
import Players from './routes/Players';
import Team from './routes/Team';
import Teams from './routes/Teams';

export default ({ user, signOut }) => {
  let content = <div>
    Your user doesn't have permissions. Contact Matt Rezin, Tim Debyl, or Ben Nelson on Slack to get permissions.
    <Button primary style={{ marginTop: '10px' }} onClick={() => Auth.currentAuthenticatedUser({ bypassCache: true })} >Check Permissions</Button>
  </div>;
  if (user && user.attributes) {
    if (user.attributes['custom:director'] || user.attributes['custom:admin']) {
      content = <Routes>
        <Route path="/player/:extPlayerId" element={<Player />} />
        <Route path="/players" element={<Players />} />
        <Route path="/team/:extTeamId" element={<Team />} />
        <Route path="/teams" element={<Teams />} />
        <Route path="*" element={<Navigate to="/teams" />} />
      </Routes>;
    }
  }

  return <BrowserRouter>
    <ToastContainer pauseOnFocusLoss={false} autoClose={2000} />
    <Header signOut={signOut} />
    <div className="container">
      {content}
    </div>
    <Footer />
  </BrowserRouter>;
};
